<script lang="ts" setup>
import { useTemplateRef, watch } from 'vue';

const props = defineProps({
  poster: {
    type: String,
    default: '',
  },
  url: {
    type: String,
    default: '',
  },
});

const videoRef = useTemplateRef('video');
const visible = defineModel('visible', { default: false, type: Boolean });

function handleClose() {
  visible.value = false;
}

watch(
  visible,
  (v) => {
    if (v) {
      videoRef.value?.play();
    } else {
      videoRef.value?.pause();
    }
  },
  { flush: 'post' },
);
</script>

<template>
  <a-modal
    v-model:open="visible"
    :centered="true"
    :closable="false"
    :mask-closable="true"
    :footer="null"
    wrap-class-name="plain-modal ht-video-preview-modal"
  >
    <div class="relative flex-center">
      <video
        ref="video"
        class="h-full max-h-[80vh] w-full max-w-[80vw] rounded-lg object-contain"
        controls
        muted
        :poster="poster"
      >
        <source :src="url" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <img
        src="@core/assets/image/im/icon-circle-x.svg"
        class="absolute -bottom-14 left-1/2 h-6 w-6 -translate-x-1/2 cursor-pointer"
        alt="close"
        @click="handleClose"
      />
    </div>
  </a-modal>
</template>

<style>
.plain-modal.ht-video-preview-modal .ant-modal {
  width: auto !important;
}
</style>
